module.exports = __webpack_public_path__ + "9f66ca69ced35d977b9556324df0ed01.png";